import FinanceApi from './FinanceApi';
export default FinanceApi;
